import { startCase } from 'lodash';
import { OrderStatusEnum } from '../constants';

export const getOrderStatusText = (status: string) => {
  switch (status) {
    case OrderStatusEnum.ADDING_ITEMS:
      return 'Draft';
    case OrderStatusEnum.SUBMITTED_BY_CUSTOMER:
      return 'Submitted';
    case OrderStatusEnum.APPROVED:
      return 'To be Billed';
    case OrderStatusEnum.CANCELLED:
      return 'Cancelled';
    default:
      return startCase(status);
  }
};

export const getOrderStatusStyle = (status: string) => {
  switch (status) {
    case OrderStatusEnum.ADDING_ITEMS:
      return {
        backgroundClass: 'status-draft-bg',
        textClass: 'status-draft-text',
      };
    case OrderStatusEnum.SUBMITTED_BY_CUSTOMER:
      return {
        backgroundClass: 'status-submitted-bg',
        textClass: 'status-submitted-text',
      };
    case OrderStatusEnum.APPROVED:
      return {
        backgroundClass: 'status-approved-bg',
        textClass: 'status-approved-text',
      };
    case OrderStatusEnum.CANCELLED:
      return {
        backgroundClass: 'status-cancelled-bg',
        textClass: 'status-cancelled-text',
      };
    default:
      return {
        backgroundClass: 'status-default-bg',
        textClass: 'status-default-text',
      };
  }
};
